module.exports = __webpack_public_path__ + "static/media/Workshops.9294ddf8.png";